<template>
    <div class="modal fade" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="0"
        ref="modalViewer"
        aria-hidden="true"
        @keyup.left="prevThumb"
        @keyup.right="nextThumb">

        <div class="cobalt-modal__viewer modal-dialog modal-dialog-centered modal-fullscreen w-100">
            <div class="p-0 m-0 w-100 h-100">

                <div class="modal-content">
                    <div class="modal-header border-0 pt-2 ps-4 pe-4 pb-2">
                        <div class="d-flex justify-content-end flex-grow-1">
                            <a v-if="currentFile.file" class="cobalt-toolbar__icon-btn" target="_blank" :download="currentFile.file.filePath" :href="Config.SERVER + 'web/' + currentFile.file.filePath">
                                <img src="@/assets/images/dashboard/base-download.svg" />
                            </a>
                            <div class="devider">|</div>
                            <button type="button" class="cobalt-toolbar__icon-btn" @click="this.hide()"><img src="@/assets/images/dashboard/base-close.svg" /></button>
                        </div>
                    </div>
                    <div class="modal-body ps-0 pe-0">
                        <div class="row p-0 m-0 w-100 h-100">
                            <div class="cm__viewer-preview" v-if="currentFile.file">
                                <div class="cm__viewer-nav left">
                                    <button type="button" class="cm__viewer-nav-btn" @click="prevThumb" v-if="this.files.length > 1">
                                        <font-awesome-icon :icon="['fas', 'angle-left']" />
                                    </button>                                    
                                </div>
                                <div class="cm__viewer-preview-pane" v-if="currentFile.type == 'image'" >
                                    <img :src="Config.SERVER + 'web/' + currentFile.file.filePath" />
                                    <p>{{ currentFile.file.name }}</p>
                                </div>
                                <div class="cm__viewer-preview-pane" v-if="currentFile.type == 'audio'" >
                                    <audio controls ref="audioFile">
                                        <source :src="Config.SERVER + 'web/' + currentFile.file.filePath" type="audio/mpeg">
                                        {{ $t("UI.viewer.audioNotSupport") }}
                                    </audio>                                    
                                </div>  
                                <div class="cm__viewer-preview-pane" v-if="currentFile.type == 'video'" >
                                    <video width="80%" height="80%" controls ref="videoFile">
                                        <source :src="Config.SERVER + 'web/' + currentFile.file.filePath" type="video/mp4">
                                        {{ $t("UI.viewer.videoNotSupport") }}
                                    </video>                             
                                </div> 
                                <div class="cm__viewer-preview-pane" v-if="currentFile.type == 'none'" >
                                    <h2>{{ $t("UI.viewer.typesNotSupport") }}</h2>
                                    <p>{{ currentFile.file.name }}</p>
                                    <a v-if="currentFile.file" class="btn cobalt-blue-button" target="_blank" :download="currentFile.file.filePath" :href="Config.SERVER + 'web/' + currentFile.file.filePath">
                                        <img src="@/assets/images/dashboard/base-download.svg" class="me-2" /> {{ $t("UI.viewer.download") }}
                                    </a>                            
                                </div>                                 
                                <div class="cm__viewer-nav right">
                                    <button type="button" class="cm__viewer-nav-btn" @click="nextThumb" v-if="this.files.length > 1">
                                        <font-awesome-icon :icon="['fas', 'angle-right']" />
                                    </button>                                    
                                </div>                                
                            </div>
                        </div>                            
                    </div>
                    <div class="modal-footer d-flex justify-content-center">
                        <div class="cm__viewer-thumbs-wrapper" v-if="this.files.length > 1">
                            <button class="cobalt-toolbar__icon-btn" @click="prevThumb"><font-awesome-icon :icon="['fas', 'angle-left']" /></button>
                            <ul class="cm__viewer-thumbs" ref="inner" :style="this.innerStyles">
                                <li 
                                    class="cm__viewer-thumb" 
                                    v-for="file in this.files" :key="file.id" 
                                    :class="{'active' : file.id == currentFile.file.id}" 
                                    @click="viewFile(file.id)"
                                >
                                    <img v-if="this.getFileTypeClass(file.name) == 'image'" :src="Config.SERVER + 'web/' + file.filePath" />
                                    <font-awesome-icon v-if="this.getFileTypeClass(file.name) == 'audio'" :icon="['fas', 'music']" />
                                    <font-awesome-icon v-if="this.getFileTypeClass(file.name) == 'video'" :icon="['fas', 'video']" />
                                    <font-awesome-icon v-if="this.getFileTypeClass(file.name) == 'docs'" :icon="['fas', 'file-lines']" />
                                    <font-awesome-icon v-if="this.getFileTypeClass(file.name) == 'arch'" :icon="['fas', 'file-zipper']" />
                                    <span class="ms-2" :title="file.name">{{ file.name }}</span>
                                </li>
                            </ul>
                            <button class="cobalt-toolbar__icon-btn" @click="nextThumb"><font-awesome-icon :icon="['fas', 'angle-right']" /></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Modal } from "bootstrap"
import { ref } from 'vue'
import Config from '../../config.js'

export default {
    components: {
    },
    props: {
        modalID: {
            type: String,
            required: true
        }
    },    
    data() {
        return {     
            Config,
            modalIDVwr: 'modalIDTsk',
            initialFileId: 0,
            currentFileIndex: 0,
            files: [],
            types: {
                image: ['svg', 'bmp', 'png', 'jpg', 'jpeg', 'gif'],
                video: ['mp4', 'avi', 'mpeg', 'mov'],
                audio: ['wav', 'mp3', 'ogg'],
                docs: ['doc', 'docx', 'pdf', 'odt', 'xls', 'xlsx'],
                arch: ['zip', '7zip', 'rar', 'tar']
            },
            step: '',
            minWidth: '220px',
            innerStyles: {},
            theModal: null,
            theModalLabel: null,
            transitioning: false
        }
    },
    computed: {
        currentFile() {
            let curFile = {
                type: '',
                file: {}
            }
            curFile.file = this.files ? this.files[this.currentFileIndex] : {}
            curFile.type = curFile.file ? this.getFileTypeClass(curFile.file.name) : 'none'

            return curFile
        }
    }, 
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})
    },
    methods: {
        shows(_id, _files) {
            this.initialFileId = _id
            this.files = _files//this.moveToCenter(_files, _id)
            this.currentFileIndex = this.getFileIndex(_id)

            this.theModal.show()

            this.$nextTick(() => {
                document.addEventListener("keydown", this.handleKeydown);
                this.setStep()
                this.resetTranslate()       
            })     
        },
        hide() {
            this.$refs.audioFile?.pause()
            this.$refs.videoFile?.pause()

            document.removeEventListener("keydown", this.handleKeydown);

            this.theModal.hide()
        },
        getFileIndex(fileId) {
            let _index = this.files.findIndex(function(file) {
                return file.id == fileId
            })  
            return _index > 0 ? _index : 0       
        },
        getFileTypeClass(fileName) {
            let type = "none"
            let ext  = "none"
            let parts = fileName.split('.')
            
            if (parts.length > 1) {
                ext = parts[parts.length - 1]
            }            

            for (var key in this.types) {
                if (this.types[key].indexOf(ext) != -1) {
                    type = key
                }
            }

            return type
        },
        viewFile(fileId) {
            this.currentFileIndex = this.getFileIndex(fileId)
        },
        setStep () {
            const innerWidth = this.$refs.inner?.scrollWidth
            const totalCards = this.files.length
            this.step = `${innerWidth / totalCards}px`
        },
        moveToCenter(arr, _id) {
            let foundElement;
            let leftPart = [];
            let rightPart = [];

            while (arr.length > 0 && !foundElement) {
                const currentElement = arr.shift();
                if (currentElement.id === _id) {
                    foundElement = currentElement;
                } else {
                    leftPart.push(currentElement);
                }
            }

            if (!foundElement) {
                // Если элемент не найден, возвращаем оригинальный массив
                return arr;
            }

            while (arr.length > 0) {
                rightPart.unshift(arr.pop());
            }

            if (leftPart.length === 0) {
                // Если искомый элемент оказался первым, добавляем его в конец leftPart
                leftPart.push(foundElement);
            } else {
                const centerIndex = Math.floor(leftPart.length / 2);
                leftPart.splice(centerIndex, 0, foundElement);
            }

            return [...leftPart, ...rightPart];
        },        
        nextThumb () {
            if (this.transitioning) return

            this.transitioning = true
            this.moveLeft()

            //this.currentFileIndex = this.currentFileIndex + 1 > this.files.length - 1 ? 0 : this.currentFileIndex + 1

            this.afterTransition(() => {
                const file = this.files.shift()
                this.files.push(file)
                this.resetTranslate()
            })
        },
        prevThumb () {
            if (this.transitioning) return

            this.transitioning = true
            this.moveRight()

            //this.currentFileIndex = this.currentFileIndex - 1 < 0 ? this.files.length - 1 : this.currentFileIndex - 1

            this.afterTransition(() => {
                const file = this.files.pop()
                this.files.unshift(file)
                this.resetTranslate()
            })
        },
        moveLeft () {
            this.innerStyles = {
                transform: `translateX(-${this.step})
                            translateX(-${this.step})`
            }
        },
        moveRight () {
            this.innerStyles = {
                transform: `translateX(${this.step})
                            translateX(-${this.step})`
            }
        },
        afterTransition (callback) {
            const listener = () => {
                callback()
                this.$refs.inner.removeEventListener('transitionend', listener)
            }
            this.$refs.inner.addEventListener('transitionend', listener)
        },
        resetTranslate () {
            this.transitioning = false
            this.innerStyles = {
                transition: 'none',
                transform: `translateX(-${this.step})`
            }
        },
        handleKeydown(event) {
            if (event.key === "ArrowLeft") {
                this.prevThumb()
            } else if (event.key === "ArrowRight") {
                this.nextThumb()
            } else if (event.key === "Escape") {
                this.hide()
            }
        }     
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
    .cobalt-modal__viewer .modal-header,
    .cobalt-modal__viewer .modal-content {
        background-color: rgba(0, 0, 0, 0.726);
    }
    .cm__viewer-preview {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        max-height: 100%;
    }    
    .cm__viewer-preview-pane {
        max-width: 80%;
        max-height: 80%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }   
    .cm__viewer-preview-pane h2 {
        font-size: 15px;
        color: #FFF;
        padding: 25px;
    }
    .cm__viewer-preview-pane img {
        max-width: 80%;
        max-height: 80%;
    }
    .cm__viewer-preview p {
        color: #FFF;
        font-size: 13px;
    }
    .cm__viewer-preview-pane p {
        padding-bottom: 25px;
    }
    .cm__viewer-nav-btn {
        color: #FFF;
        font-size: 32px;
        border: none;
        background: none;
        opacity: .5;
    }
    .cm__viewer-nav-btn:hover {
        opacity: 1;
    }
    .cm__viewer-nav.left {
        left: 10px;
    }
    .cm__viewer-nav.left {
        right: 10px;
    }   
    .cm__viewer-thumbs-wrapper {
        display: flex;
        align-items: center;
        max-width: 90%;
        width: 90%;
    } 
    .cm__viewer-thumbs-wrapper .cobalt-toolbar__icon-btn {
        color: #FFF;
    }
    .cm__viewer-thumbs {
        flex:1;
        list-style: none;
        display: flex;
        flex-direction: row;
        justify-content: center;
        white-space: nowrap;
        overflow: hidden;
        margin: 0 25px;
        padding: 0;
        transition: transform 0.2s;
    }
    .cm__viewer-thumbs li {
        display: flex;
        justify-content: flex-start;
        border: 1px solid #00000085;
        border-radius: 3px;
        margin: 5px;
        padding: 5px 10px;
        font-size: 12px;
        color: #FFF;
        overflow: hidden;
        max-width: 20%;
        min-width: calc(12.5% - 10px);
    }
    .cm__viewer-thumbs li:hover {
        border: 1px solid #CCC;
    }    
    .cm__viewer-thumbs li.active {
        border-color: #056385;
    }
    .cm__viewer-thumbs li span {
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .cm__viewer-thumb {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .cm__viewer-thumb img {
        max-width: 24px;
        max-height: 24px;
    }
</style>